<template>
  <div>
    <Navbar v-if="$route.name == 'bulkmailing'" />
    <Breadcrumb v-if="$route.name == 'bulkmailing'" />
    
    <!-- Loading Overlay -->
    <div v-if="sending" class="position-fixed top-0 start-0 w-100 h-100" style="z-index: 1050; background-color: rgba(0,0,0,0.5);">
      <div class="position-absolute top-50 start-50 translate-middle text-center text-white">
        <div class="spinner-border spinner-border-sm mb-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div>Sending e-mails...{{ sendingNo }}/{{ sendToIds.length }}</div>
      </div>
    </div>

    <div class="col-12 px-4">
      <div class="row">
        <div class="col mb-2">
          Selected <b>{{ sendToIds.length }}</b> consultant<span v-show="sendToIds.length>1">s with unique e-mail</span>
          <span v-show="sendToIds.length>0">
            <br />
            E-mail<span v-show="emailsArray.length>1">s</span>:
            <span v-if="idsArray.length > 10">(showing first 10)<br /></span>
            (<span v-for="(email, index) in emailsArray" :key="index">
              <span v-show="index < 10">{{ email }}, </span>
              <span v-show="index == 9">...</span>
            </span>)
          </span>
        </div>
      </div>
    </div>

    <div class="col-12 px-4">
      <div class="row">
        <div class="col">
          <h4>Mail template</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label for="template_id" class="form-label">Select template</label>
          <select
            id="template_id"
            class="form-select"
            v-model="template_id"
            @change="template_get"
          >
            <option value="-1">Select template</option>
            <option v-for="option in templates" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mb-3" v-show="template_id>0">
        <div class="col">
          <label for="mailtype" class="form-label">Mail type</label>
          <select
            id="mailtype"
            class="form-select"
            v-model="mailtype"
          >
            <option value="">Select mail type</option>
            <option v-for="option in mailtypes" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>

      <div class="row pt-4 mt-4" v-show="!sending">
        <div class="col text-start">
          <button
            class="btn btn-secondary"
            @click="emitSendingBulkEmail(false)"
          >
            Back to list
          </button>
        </div>
        <div class="col text-end">
          <button
            v-if="template_id > 0 && mailtype != ''"
            class="btn btn-primary"
            @click="sendmails"
          >
            Send e-mails
          </button>
        </div>
      </div>

      <div class="row pt-4" v-show="template_id>0 && mailtype !=''">
        <div class="col-12" v-if="user_id==1">
          <input
            v-model="fromId"
            placeholder="From ID"
            type="text"
            autocomplete="off"
            class="form-control col-2"
          />
        </div>

        <h5 class="ps-3">Preview</h5>
        <div class="col-12"><b>Subject:</b> {{template_subject}}</div>
        <div class="col-12"><b>E-mail body:</b></div>
        <div v-html="template"></div>
      </div>

      <div class="row pt-4 mt-4" v-show="!sending">
        <div class="col text-start">
          <button
            class="btn btn-secondary"
            @click="emitSendingBulkEmail(false)"
          >
            Back to list
          </button>
        </div>
        <div class="col text-end">
          <button
            v-if="template_id > 0 && mailtype != ''"
            class="btn btn-primary"
            @click="sendmails"
          >
            Send e-mails
          </button>
        </div>
      </div>
    </div>

    <div v-if="sent" class="alert alert-success alert-dismissible fade show mt-4 pt-4 mx-4" role="alert">
      {{ sentmsg }}
      <button type="button" class="btn-close" @click="sent = false"></button>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Navbar from "@/components/Navbar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

const mailtypes = [
  { value: "newsletter", text: "Newsletter" },
  { value: "general", text: "General" },
  { value: "priority", text: "Priority" },
];

export default {
  name: "BulkMailing",

  components: {
    Navbar,
    Breadcrumb,
  },
  props: {
    idsArray: {
      type: Array,
      required: true,
    },
    emailsArray: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      fromId: 0,
      user_id: this.$store.state.user_id,
      loading: false,
      templates: [],
      template_id: -1,
      template: '',
      template_subject: '',
      first_name: "Susan",
      family_name: "Wheelan",
      email: "gdq@gdq.se",
      mailtype: '',
      mailtypes,
      unsubscribe: 'Click here to unsubscribe',
      sending: false,
      sent: false,
      sentmsg: '',
      sendToIds: [],
      errcount: 0,
      sentcount: 0,
      sendingNo: 0,
    };
  },
  created() {
    this.templates_get();
    const seen = new Set();
    const uniqueEmails = [];
    const uniqueIds = [];
    this.emailsArray.forEach((email, idx) => {
      if (!seen.has(email)) {
        seen.add(email);
        uniqueEmails.push(email);
        uniqueIds.push(this.idsArray[idx]);
      } else {
        console.warn(`Duplicate email found: ${email}`);
      }
    });
    this.sendToIds = uniqueIds;
  },
  methods: {
    emitSendingBulkEmail(value) {
      this.$emit('stopsendingemail', value);
    },
    templates_get() {
        const filter = {
            deleted: {
              operator: '=',
              value: 0,
            }
          }
        this.$store.dispatch('records_readlist', { table_name: 'g_bulkemailtemplates', filter })
        .then((response) => {
            this.templates = response.data.result.map((template) => {
                return {
                    value: template.id,
                    text: template.template_name,
                };
            });
        });
    },
    template_get() {
      console.log('Getting template');
      const selectedTemplateId = this.template_id;
      if (selectedTemplateId != 0) {
        console.log('Here');
        this.$store.dispatch('record_read', { table_name: 'g_bulkemailtemplates', id: selectedTemplateId })
        .then((response) => {
            this.template = response.data.template ?
              response.data.template
                .replaceAll('{{firstName}}', this.first_name)
                .replaceAll('{{familyName}}', this.family_name)
                .replaceAll('{{email}}', this.email)
                .replaceAll('{{unsubscribe}}', this.unsubscribe):
                '';
            this.template_subject = response.data.template ? response.data.template_subject : '';
        });
      } else {
        this.template = '';
        this.template_subject = '';
      }
    },
    async sendmails() {
      this.errcount = 0;
      this.sentcount = 0;
      this.sending = true;
      this.sent = false;
      this.sentmsg = '';
      this.sendingNo = 0;

      const filteredIds = this.sendToIds.filter(id => parseInt(id) >= parseInt(this.fromId));

      this.sendToIds = filteredIds;
      
      for (const id of this.sendToIds) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        try {
          const res = await this.$store.dispatch('bulkmail_send', {
            template_id: this.template_id,
            mailtype: this.mailtype,
            idsArray: [id],
          });
          this.sendingNo++;
          if (res.data && res.data.sentcount > 0) {
            this.sentcount += res.data.sentcount;
          }
          if (res.data && res.data.errcount > 0) {
            this.errcount += res.data.errcount;
          }
        } catch (e) {
          this.errcount++;
        }
      }
      this.sending = false;
      this.sent = true;
      this.sentmsg = `E-mails sent to ${this.sentcount} consultants ${this.errcount > 0 ? `with ${this.errcount} errors` : ''}.`;
      this.template_id = -1;
      this.mailtype = '';
      this.template = '';
      this.template_subject = '';
      this.$emit('emailsSent', { sentcount: this.sentcount, errcount: this.errcount });
    },
  },
};
</script>
<style scoped></style>
